import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    CatalogosGeneralesServiceProxy,
    EventoResponse,
    EventoGetListQuery,
    ComboboxItemDtoOfLong
} from '../../../../shared/service-proxies/service-proxies';


@Component({
    templateUrl: 'busquedaeventos-grid.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class BusquedaEventosGridComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    data: EventoResponse[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;
    query: EventoGetListQuery = new EventoGetListQuery();

    tiposEventosList: ComboboxItemDtoOfLong[] = [];
    tiposCatalogosList: ComboboxItemDtoOfLong[] = [];

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private service: CatalogosGeneralesServiceProxy

    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.cols = [
            { field: 'id', header: this.l('Busquedas.Eventos.Id'), isActive: true },
            { field: 'tipoCatalogoDesc', header: this.l('Busquedas.Eventos.TipoCatalogo'), isActive: true },
            { field: 'descripcion', header: this.l('Busquedas.Eventos.Descripcion'), isActive: true },
            { field: 'codigoOficial', header: this.l('Busquedas.Eventos.CodigoOficial'), isActive: true },
        ];

        self.form = self.formBuilder.group({
            filterText: [null],
            tipoEvento: [null],
            tipoCatalogo: [null]
        });

        self.getTiposEventosList();

        self.query = new EventoGetListQuery();
        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }

    getTiposEventosList(): void {
        const self = this;

        self.service.getTiposEventosForCombobox()
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.tiposEventosList = data;
            });
    }

    changeTipoEvento(): void {
        const self = this;

        if (self.f.tipoEvento.value) {
            self.getTiposCatalogosList();
        } else {
            self.tiposCatalogosList = [];
        }
    }

    getTiposCatalogosList(): void {
        const self = this;

        self.service.getTiposCatalogosForCombobox(self.f.tipoEvento.value)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.tiposCatalogosList = data;
            });
    }


    getList(): void {
        const self = this;

        self.query.filter = self.f.filterText.value;
        self.query.tipoEvento = self.f.tipoEvento.value;
        self.query.tipoCatalogo = self.f.tipoCatalogo.value;
        self.blockedDocument = true;

        self.service.getEventosList(self.query)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.data = data.items;

                // Calculate paged table summary
                self.pagedTableSummary = self.getPagedTableSummay(data.totalCount, self.query.pageNumber, self.query.pageSize);
            });
    }

    loadData(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.query.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.query.sorting = '';
        }

        self.query.pageNumber = 1 + (event.first / event.rows);
        self.query.pageSize = event.rows;

        self.getList();
    }

    filterSearch($event): void {
        const self = this;

        $event.preventDefault();

        self.query.pageNumber = 1;
        self.query.pageSize = 10;
        self.getList();
    }

    seleccionar(rowData: EventoResponse): void {
        const self = this;

        self.close(rowData);
    }


    close(seleccionado: EventoResponse): void {
        const self = this;

        self.modalRef.close(seleccionado);
    }
}
